export enum ColumnTypes {
  Boolean = 'Boolean',
  Currency = 'Currency',
  Date = 'Date',
  Number = 'Number',
  Percent = 'Percent',
  Period = 'Period',
  Text = 'Text',
  Year = 'Year'
}
